import { ArrowUpRightIcon } from "lucide-react";
import React from "react";

function JobDetails({ guideDetails, handleViewJd }) {
  const {
    companyName,
    jobTitle,
    yearsOfExperience,
    creationTime,
    jobLocation,
  } = guideDetails;

  const formatDate = (dateString) => {
    if (!dateString) return "NA";
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  return (
    <div className="  p-2 relative shadow-sm driver-single-guide-user-details-section border-b-2 pb-2">
      <div className="text-[#101828] text-[1.2rem] font-bold">
        {jobTitle?.charAt(0).toUpperCase() + jobTitle.slice(1) || "Job Title"}
      </div>
      <div className="text-[#101828] text-[1rem] font-medium mb-[0.4rem]">
        {companyName?.charAt(0).toUpperCase() + companyName.slice(1) ||
          "Company Name"}
      </div>
      <p className="text-[#475467] font-medium text-[14px] mb-[0.32rem]">
        {yearsOfExperience}+ years of experience
      </p>
      <p className="text-[#475467] font-medium text-[14px] mb-[0.32rem]">
        Created on {formatDate(creationTime)}
      </p>
      <p className="text-[#475467] font-medium text-[14px] mb-[0.5rem]">
        {jobLocation || "Location not specified"}
      </p>

      <span
        className="flex w-[90px] ml-auto justify-end items-center hover-effect gap-1 text-amber-600 font-semibold hover:text-amber-500 text-[0.85rem] cursor-pointer"
        onClick={() => handleViewJd()}
      >
        View JD
        <ArrowUpRightIcon
          className="hover:text-amber-500"
          size={20}
          strokeWidth={2.5}
          color="currentColor"
        />
      </span>
    </div>
  );
}

export default JobDetails;
